import { Close, ContentCopy } from "@mui/icons-material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
} from "@mui/material";

interface XmlDialogProps {
  open: boolean;
  xml: string;
  onClose: () => void;
}

export const XmlDialog = ({ open, xml, onClose }: XmlDialogProps) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(xml);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        XML da Guia TISS gerado
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            whiteSpace: "pre-wrap",
            fontFamily: "monospace",
            fontSize: "0.875rem",
            backgroundColor: "#f5f5f5",
            padding: 2,
            borderRadius: 1,
            maxHeight: "60vh",
            overflow: "auto",
          }}
        >
          {xml}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={copyToClipboard} startIcon={<ContentCopy />}>
          Copiar para Área de Transferência
        </Button>
        <Button onClick={onClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
